export const intercomArticleIds = {
  CONDITION_SETUP_GUIDE: "12522108",
  CUSTOM_NUMBER_FORMAT_LIMITATION: "10426576",
};
